import React from 'react';
import styled from 'styled-components';
import colors from '../../../theme/colors';
import { Text } from './Text/Text';

type ElementNode = JSX.Element | JSX.Element[];

interface GivelifyBannerProps {
  icon: ElementNode;
  header: ElementNode | string;
  body: ElementNode | string;
  className?: string;
  marginBottom?: string;
  borderColor?: keyof typeof colors;
  backgroundColor?: keyof typeof colors;
}

const StyledDiv = styled.div<{
  marginBottom: string;
  borderColor?: keyof typeof colors;
  backgroundColor?: keyof typeof colors;
}>`
  gap: 8px;
  padding: 16px;
  display: flex;
  font-size: 14px;
  border-radius: 16px;
  margin-bottom: ${({ marginBottom }) => marginBottom};
  ${({ backgroundColor }) =>
    backgroundColor ? `background-color: ${colors[backgroundColor]};` : ''}
  border: 2px solid
    ${({ borderColor }) =>
    borderColor ? colors[borderColor] : colors.borderComponentInfo};
  svg {
    width: 24px;
    height: 24px;
  }
  .banner-message {
    text-align: left;
  }
`;

const GivelifyBanner: React.FC<GivelifyBannerProps> = ({
  icon,
  header,
  body,
  marginBottom = '24px',
  backgroundColor,
  borderColor,
  className
}) => {
  return (
    <StyledDiv
      marginBottom={marginBottom}
      borderColor={borderColor}
      backgroundColor={backgroundColor}
      className={className}
    >
      <div className="info-icon">{icon}</div>
      <div className="banner-message">
        <Text
          weight="extraBold"
          variant="small"
        >
          {header}
        </Text>
        <Text
          weight="light"
          variant="small"
        >
          {body}
        </Text>
      </div>
    </StyledDiv>
  );
};

export default GivelifyBanner;
